import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../hooks/toast'
import { converterNegociacaoBoleto } from '../../pages/Negociacoes/fetch'
import { convertDecimalCurrency } from '../../utils/utils'
import { timeFromString } from '../DadosCadastroPF/masks'
import { dateFromString } from '../Filter/masks'
import { getStatusCotacao, getStatusNegociacao } from '../OperationCard/utils'
import * as S from './styles'
import { getPedidoStatusColor } from './utils'
import IconRefresh from '../../assets/img/icon-refresh.svg'
import { useState } from 'react'
import { sendToConverterCheckout } from '../../utils/rotaConverter'
import { useQueryClient } from 'react-query'
import Loader from '../Loader'

interface FichaNegociacaoCotacao {}

const FichaNegociacaoCotacao = ({
  type,
  showModal,
  showModalMessage,
  setEsgotadoBoletoMessage,
  pedidos,
  setPedido
}) => {
  const history = useHistory()
  const queryClient = useQueryClient()
  const { addToast }: any = useToast()
  const [esgotadoMessage, setEsgotadoMessage] = useState()
  const [loader, setLoader] = useState<boolean>(false)

  const showButtonConverter = (pedido) => {
    if (
      (pedido?.DescricaoSituacao === 'Negociação Avaliada' &&
        pedido?.Expirado === false) ||
      (pedido?.DescricaoSituacao === 'Cotação' && pedido?.Expirado === false)
    ) {
      return true
    } else {
      return false
    }
  }

  const handleConverter = async (pedido) => {
    const formaPagamento = pedido.DetalhePagamento.DescricaoFormaPagamento

    setPedido(pedido)
    setLoader(true)

    if (formaPagamento.includes('Boleto') || formaPagamento.includes('Pix')) {
      let res: any = await converterNegociacaoBoleto(pedido, type.toUpperCase())
      queryClient.refetchQueries('cotacao')
      queryClient.refetchQueries('negociacao')

      if (res?.includes('Convertido')) {
        sendToConverterCheckout(res, formaPagamento)
      } else if (res?.includes('esgotou')) {
        setEsgotadoBoletoMessage(res)
        setEsgotadoMessage(res)
        showModalMessage()
        setLoader(false)
      } else {
        addToast({
          type: 'error',
          title: 'Ocorreu um erro ao gerar Pedido. Tente novamente',
          description: `${res}`
        })
      }
      setLoader(false)
    } else {
      setLoader(false)
      showModal()
    }
  }

  return (
    <>
      {loader && <Loader />}
      {pedidos?.Data.map((pedido) => {
        return (
          <S.Wrapper
            key={pedido?.Id}
            buttonConverter={!!showButtonConverter(pedido)}
            type={
              type === 'n'
                ? getStatusNegociacao(pedido)
                : getStatusCotacao(pedido)
            }
          >
            {type === 'n' ? (
              <>
                <S.CardInfo>
                  <p className="numero">
                    <strong>Nº {pedido?.Id}</strong>
                  </p>

                  <p>
                    <strong>Data: </strong>
                    {dateFromString(pedido?.DataRequisicao)} às{' '}
                    {timeFromString(pedido?.DataRequisicao)}
                  </p>

                  <p>
                    <strong>Desconto: </strong>
                    {convertDecimalCurrency(pedido?.ValorDesconto)}
                  </p>

                  <p>
                    <strong>Valor Total: </strong>
                    {convertDecimalCurrency(pedido?.ValorTotal)}
                  </p>
                </S.CardInfo>
              </>
            ) : (
              <>
                <S.CardInfo>
                  <p className="numero">
                    <strong>Nº {pedido?.Id}</strong>
                  </p>

                  <p>
                    <strong>Validade: </strong>
                    {dateFromString(pedido?.DataValidade)} às{' '}
                    {timeFromString(pedido?.DataValidade)}
                  </p>

                  <p>
                    <strong>Data: </strong>
                    {dateFromString(pedido?.DataRequisicao)} às{' '}
                    {timeFromString(pedido?.DataRequisicao)}
                  </p>

                  <p>
                    <strong>Valor Total: </strong>
                    {convertDecimalCurrency(pedido?.ValorTotal)}
                  </p>
                </S.CardInfo>
              </>
            )}

            {!!showButtonConverter(pedido) ? (
              <S.CardButton
                className="button-small button-success"
                // Fetch Original
                onClick={() => handleConverter(pedido)}
              >
                <img src={IconRefresh} alt="Converter" />
                Converter
              </S.CardButton>
            ) : (
              <S.Tag
                color={getPedidoStatusColor(pedido?.DescricaoSituacao)}
                type={
                  type === 'n'
                    ? getStatusNegociacao(pedido)
                    : getStatusCotacao(pedido)
                }
              >
                {type === 'n'
                  ? getStatusNegociacao(pedido)
                  : getStatusCotacao(pedido)}
              </S.Tag>
            )}

            <div className="detalhe-link">
              <button
                onClick={() => {
                  type === 'n'
                    ? history.push(`/negociacoes/${pedido?.Id}`, {
                        redirect: false,
                        from: 'negociacoes'
                      })
                    : history.push(`/cotacoes/${pedido?.Id}`, {
                        redirect: false,
                        from: 'cotacoes'
                      })
                }}
              >
                Ver Detalhes
              </button>
            </div>
          </S.Wrapper>
        )
      })}
    </>
  )
}

export default FichaNegociacaoCotacao
